import styles from './Introduction.module.scss'
import { useRef, useEffect } from 'react'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/dist/ScrollToPlugin'
gsap.registerPlugin(ScrollTrigger)

const Introduction: React.FC = () => {
  const img = useRef<HTMLImageElement>()
  const section = useRef<HTMLDivElement>()
  const slide = useRef<HTMLDivElement>()
  const spImg = useRef<HTMLDivElement>()
  const pcImg = useRef<HTMLDivElement>()
  useEffect(() => {
    gsap.to(slide.current, {
      width: 0,
      duration: 0.8,
      scrollTrigger: {
        trigger: section.current,
        start: 'top-=1 top',
      },
    })
    gsap.to(pcImg.current, {
      y: -150,
      scrollTrigger: {
        trigger: section.current,
        start: 'top top',
        scrub: true,
      },
    })
    gsap.to(spImg.current, {
      webkitFilter: 'blur(5px)',
      scrollTrigger: {
        trigger: section.current,
        start: 'top+=100px top',
        scrub: true,
      },
    })
  }, [])
  return (
    <div className={styles.introduction} ref={section}>
      <div className={styles.text_wrapper}>
        <div className={styles.left}>
          <div className={styles.slider} ref={slide}></div>
          <h1 className={styles.h1}>
            ユーザーに素早く
            <br className={styles.sp} />
            <span>価値を届けるための</span>
            <br />
            デザインシステム
            <br className={styles.sp} />
            <span>構築支援サービス</span>
          </h1>
          <p>
            ブランドビジュアルの再構築から
            <br />
            効率的なエンジニアリングまで
            <br className={styles.sp} />
            サポートします。
          </p>
        </div>
      </div>
      <a className={styles.button} href="#about">
        <img src="/images/LP/designsystem/arrowToBottom.svg" alt="" />
      </a>
      <div className={`${styles.img_wrapper} ${styles.sp}`} ref={spImg}>
        <img src="/images/LP/designsystem/topImg.png" alt="" ref={img} />
      </div>
      <div className={`${styles.img_wrapper} ${styles.pc}`} ref={pcImg}>
        <img src="/images/LP/designsystem/topImg.png" alt="" ref={img} />
      </div>
    </div>
  )
}
export default Introduction
